/*
 * 印度尼西亚 CPS + 保险声明（版本3，新增文案，PRD 6.1.2）
 * 路由：/RetailGlobal/Protocol/PrivacyCollect/id/directCPSCare
 */
import React, { memo } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">To deliver the product(s) you order in our store to the address you designate, Xiaomi will collect <strong>your name, phone number and delivery address</strong> as you provide here and <strong>share them with our delivery service partner</strong> that will deliver the product(s) to you.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">The legal basis for this processing of your personal data is that <strong>it is necessary for performing a contract to which you are a party.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may exercise your data protection rights (e.g., access, rectification and/or erasure) through our Privacy Support Platform (
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/support/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may find further information about the processing of your personal data by referring to our Privacy Policy (
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/all/languages/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Please review and confirm the terms in the "Xiaomi Care" Terms of Use (<a href="https://www.mi.co.id/id/support/terms/xiaomi-care/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://www.mi.co.id/id/support/terms/xiaomi-care/</span></a>) before purchase, and sign to acknowledge.</span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">By signing below, you acknowledge that you have read, understood, and agree to the above terms.</span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Untuk mengirimkan produk yang Anda pesan di toko kami ke alamat yang Anda tentukan, Xiaomi akan mengumpulkan nama, nomor telepon, dan alamat pengiriman yang Anda berikan di sini, serta membagikan informasi tersebut kepada mitra layanan pengiriman kami yang akan mengantarkan produk kepada Anda.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Dasar hukum pemrosesan data pribadi Anda adalah bahwa pemrosesan tersebut diperlukan untuk pelaksanaan kontrak yang melibatkan Anda sebagai salah satu pihak.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Anda dapat menggunakan hak-hak perlindungan data pribadi Anda (misalnya, hak untuk mengakses, memperbaiki, dan/atau menghapus data pribadi) melalui Platform Dukungan Privasi kami (
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/support/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Informasi lebih lanjut mengenai pemrosesan data pribadi Anda dapat ditemukan dalam Kebijakan Privasi kami (
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/all/languages/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Harap baca Syarat dan Ketentuan Xiaomi Care (
                        <a href="https://www.mi.co.id/id/support/terms/xiaomi-care/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://www.mi.co.id/id/support/terms/xiaomi-care/
                            </span>
                        </a>
                        ) dengan saksama sebelum melakukan pembelian.
                    </span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial; font-style:italic">Dengan menandatangani di bawah ini, Anda menyatakan bahwa Anda telah membaca, memahami, dan menyetujui ketentuan-ketentuan di atas.</span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)
